import React, {MouseEvent} from "react";
import classNames from "classnames";


import './TextLink.css';


export interface TextLinkProps {
    onClick: (event: MouseEvent) => void;
    text: string;
    className?: string;
    href?: string;
    target?: string;
    inheritColor?: boolean
}

export const TextLink = (
    {
        onClick,
        text,
        href,
        target,
        className,
        inheritColor = false
    }: TextLinkProps
) => {

    return (
        <a
            className={classNames({
                'TextLink': true,
                'TextLink__inheritColor': inheritColor,
                [className!]: !!className,
            })}
            href={href}
            target={target}
            onClick={onClick}
        >
            {text}
        </a>
    )
}
